module.exports = __webpack_public_path__ + "img/conny-f-stage3-hungry.fd1784b6.png";